import React from 'react';
import { motion } from 'framer-motion';
import { Building2, Home, Car, Sun, GraduationCap, Briefcase, Shield } from 'lucide-react';
export const IndustryIcons = () => {
  const industries = [{
    icon: Shield,
    label: 'Insurance'
  }, {
    icon: Home,
    label: 'Real Estate'
  }, {
    icon: Car,
    label: 'Auto Sales'
  }, {
    icon: Sun,
    label: 'Solar'
  }, {
    icon: GraduationCap,
    label: 'Coaching'
  }, {
    icon: Briefcase,
    label: 'Agencies'
  }, {
    icon: Building2,
    label: 'Mortgage'
  }];
  return <div className="mb-12" data-id="element-108">
      <p className="text-center text-[#F5F5F7]/60 text-sm mb-6" data-id="element-109">
        Trusted by 7-8 figure sales organizations in:
      </p>
      <div className="flex flex-wrap justify-center gap-4 sm:gap-6" data-id="element-110">
        {industries.map((industry, index) => {
        const Icon = industry.icon;
        return <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05
        }} className="flex flex-col items-center gap-2" data-id="element-111">
              <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-[#0A1BFF]/20 to-[#6366F1]/20 border border-[#6366F1]/30 flex items-center justify-center" data-id="element-112">
                <Icon className="w-6 h-6 text-[#F5F5F7]/70" data-id="element-113" />
              </div>
              <span className="text-xs text-[#F5F5F7]/60" data-id="element-114">
                {industry.label}
              </span>
            </motion.div>;
      })}
      </div>
    </div>;
};